import React from 'react';
import {Text} from 'react-native';

import {
  Code,
  FlexView,
  Footprint,
  Heading,
  Spacer,
} from '/component/base/Storybook';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import Button from '../Button';

export default () => (
  <>
    <Heading level={1}>Text-Link Button</Heading>
    <Spacer size={16} />
    <Text>
      Setting <Code>{'type="textLink"'}</Code> on the{' '}
      <Code>{'<Button />'}</Code> component will render a text-link button.
    </Text>
    <Spacer size={16} />
    <Text>
      Text-link button has the same overall dimension (height, padding, etc.) as
      normal buttons except for the lack of a min-width.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <Footprint>
        <Button type="textLink">?</Button>
      </Footprint>
      <Spacer direction="horizontal" size={16} />
      <Footprint>
        <Button type="textLink">¯\_(ツ)_/¯</Button>
      </Footprint>
    </FlexView>
    <Spacer size={16} />
    <Text>
      Like primary button's background color, by default the current user's
      competency level will be used to determine the text-link button's text
      color.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Button type="textLink">Label</Button>
        <Spacer size={6} />
        <Text>Active</Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Button type="textLink" disabled={true}>
          Label
        </Button>
        <Spacer size={6} />
        <Code>{'disabled={true}'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={24} />
    <Heading level={2}>Overriding Competency Level</Heading>
    <Spacer size={16} />
    <Text>
      When the <Code>competency</Code> prop is set to a valid value it will
      override the current user's competency level and the corresponding text
      color for the button will be used instead.
    </Text>
    <Spacer size={16} />
    <FlexView>
      <Button type="textLink" competency={COACH}>
        Label
      </Button>
      <Spacer size={6} />
      <Code>{'competency={COACH}'}</Code>
    </FlexView>
    <Spacer size={10} />
    <FlexView>
      <Button type="textLink" competency={BUSINESS_COACH}>
        Label
      </Button>
      <Spacer size={6} />
      <Code>{'competency={BUSINESS_COACH}'}</Code>
    </FlexView>
    <Spacer size={10} />
    <FlexView>
      <Button type="textLink" competency={BUSINESS_LEADER}>
        Label
      </Button>
      <Spacer size={6} />
      <Code>{'competency={BUSINESS_LEADER}'}</Code>
    </FlexView>
  </>
);
